import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'ngcDateBetween'
})
export class DateBetweenPipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    transform(value: string, dateFormat?: string): string {
        const colonIndex = value.indexOf(':');
        const startDate = new Date(value.substring(0, colonIndex) + 'T00:00:00');
        const endDate = new Date(value.substring(colonIndex + 1) + 'T00:00:00');

        return this.datePipe.transform(startDate, dateFormat) + '-' + this.datePipe.transform(endDate, dateFormat);
    }
}
